import { defineComponent as _defineComponent } from 'vue';
import { DialogContent, useForwardPropsEmits, } from 'reka-ui';
import { computed } from 'vue';
import { cn } from '../utils';
export default /*@__PURE__*/ _defineComponent({
    __name: 'DialogContent',
    props: {
        forceMount: { type: Boolean, required: false },
        disableOutsidePointerEvents: { type: Boolean, required: false },
        asChild: { type: Boolean, required: false },
        as: { type: null, required: false },
        class: { type: [Boolean, null, String, Object, Array], required: false, skipCheck: true }
    },
    emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "openAutoFocus", "closeAutoFocus"],
    setup(__props, { expose: __expose, emit: __emit }) {
        __expose();
        const props = __props;
        const emits = __emit;
        const delegatedProps = computed(() => {
            const { class: _, ...delegated } = props;
            return delegated;
        });
        const forwarded = useForwardPropsEmits(delegatedProps, emits);
        const __returned__ = { props, emits, delegatedProps, forwarded, get DialogContent() { return DialogContent; }, get cn() { return cn; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
